export const defaultMenuItems = [
  { path: '/dashboard', icon: 'HomeLogo', label: 'Home' },
  { path: '/dashboard/contact', icon: 'ContactsLogo', label: 'Contacts Overview' },
  { path: '/dashboard/campaign/campaign-create', icon: 'SMSLogo', label: 'SMS Campaign Builder' },
  {
    path: '/dashboard/campaign/overview',
    icon: 'SMSInsightsLogo',
    label: 'SMS Campaign Overview',
  },
  { path: '/dashboard/campaign-analytics', icon: 'GraphLogo', label: 'SMS Analytics' },
];

export const additionalMenuItems = [
  { path: '/dashboard/email-api-home', icon: 'EmailLogo', label: 'Email API' },
  {
    path: '/dashboard/account/api-message',
    icon: 'DevelopersLogo',
    label: 'Developer',
  },
  {
    path: 'https://help.elfo.com/',
    icon: 'HelpLogo',
    label: 'Help',
    external: true,
  },
];
